import React, { PropTypes, Component } from 'react';
import Moment from 'moment';
import Blazy from 'blazy';
import Classes from './gridhelper/generatePostClassesWithTerms';
const $ = jQuery;

class latestGridLayoutFour extends Component {
  constructor(props) {
    super(props);
    this.hideLoadingGig = this.hideLoadingGig.bind(this);
    this.state = {
      isotope: false,
    };
  }
  componentDidMount() {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });
  }
  componentWillReceiveProps(nextProps) {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });    
  }
  componentWillMount() {
    const post = this.props.post;
    this.termAsClasses = Classes.generatePostClassesWithTerms(post.terms);
    this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
  }
  hideLoadingGig(ele) {
    const id = this.props.post.ID;
     $('.dummyClass' + id).removeClass('lazyLoading');
  }
  handleClick(e) {
    e.preventDefault();
  }
  render() {
    const post = this.props.post;
    const view = this.props.view;
    let termAsClasses = this.termAsClasses;
    termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
    let imgStyle = null;
    if (this.state.isotope === false) {
      imgStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        width: '100%',
        height: '100%',
      };
    } else {
      imgStyle = {
        backgroundImage: 'url(' + post.thumb_url + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        width: '100%',
        height: '100%',
      };
    }
    const showtag = (item) => {
      return (
        <span className="post-tag">{item}</span>
        );
    };

    return (<div>
      { view === 'grid' ?
      <div className="rq-image-grid">
        <div className="rq-grid-normal full-width-bg-image no-border-radius">
           <div className="post-image-container rq-latest-two-grid">
            <a href={post.post_link}>
              <div className={ this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy rq-absolute-container dark-overlay light-overlay dummyClass' + post.ID : 'image-hover-coantainer rq-absolute-container dark-overlay light-overlay' } style={imgStyle} data-src={this.state.isotope === false ? post.thumb_url : null}>
                <div className="img-overlay"><i className="ion-link"></i></div>
              </div>
              <div className="on-hover-cotnent">
                <div className="rq-title-footer with-bottom-panel">
                  <div className="rq-title-content">
                    <h3>{post.post_title}</h3>
                  </div>

                  <span className="post-date">{ Moment(post.post_date).format('MMM  YYYY') }</span>
                  <span className="rq-tag-container">{ post.terms.hasOwnProperty('post_tag') ? post.terms.post_tag.map(showtag) : null }</span>
                </div>
              </div>
              {
               // <span className="like-icon-forth"><i className="ion-ios-heart-outline"></i></span>
              }

            </a>
          </div>
        </div>
      </div>
      :
      <div className="flex-row">
        <div className="flex-md-12 flex-sm-12 flex-xs-12">
          <div className="rq-image-grid">
            <div className="rq-grid-normal with-left-image">
              <div className="flex-row">
                <div className={this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list' } style={imgStyle} data-src={this.state.isotope === false ? post.thumb_url : null}>
                  <div className="img-overlay"><a href={post.post_link}><i className="ion-android-add"></i></a></div>
                </div>
                <div className="flex-md-7 flex-sm-12 flex-xs-12">
                  <div className="post-content">
                    <h2><a href={post.post_link}>{post.post_title}</a></h2>
                    <span className="post-date">{ Moment(post.post_date).format('ll') }</span>
                    <div className={'post-text' + termAsClasses} dangerouslySetInnerHTML={{ __html: post.post_excerpt.slice(0, 70) + '...' }}></div>
                    <a href={post.post_link} className="btn btn-blog">{API.LANG.MORE}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    </div>);
  }
}

ReactiveTemplates['latestGridLayoutFour'] = latestGridLayoutFour;

ReactiveLayouts.push({
  'key': 'latestGridLayoutFour',
  // 'image_url': API.IMG + 'effect-steve.jpg',
  'type': 'all',
  'gridName': 'PrettyGrid',

});



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/layout/grid/prettyGrid.js